import { defineMessages } from 'react-intl'


export default defineMessages({
  accept: {
    defaultMessage: 'Accept',
    id: 'consent-prompt-content.accept',
  },

  decline: {
    defaultMessage: 'Decline',
    id: 'consent-prompt-content.decline',
  },

  poweredBy: {
    defaultMessage: '<link>Cookie Consent Manager</link> by {logo}',
    id: 'consent-prompt-content.powered-by',
  },
})
